__turbopack_context__.v({
  "avatar": "share-qr-code-module-scss-module__wUyz3q__avatar",
  "button": "share-qr-code-module-scss-module__wUyz3q__button",
  "container": "share-qr-code-module-scss-module__wUyz3q__container",
  "copy": "share-qr-code-module-scss-module__wUyz3q__copy",
  "footer": "share-qr-code-module-scss-module__wUyz3q__footer",
  "icon": "share-qr-code-module-scss-module__wUyz3q__icon",
  "link": "share-qr-code-module-scss-module__wUyz3q__link",
  "name": "share-qr-code-module-scss-module__wUyz3q__name",
  "qrcode": "share-qr-code-module-scss-module__wUyz3q__qrcode",
  "qrcode-container": "share-qr-code-module-scss-module__wUyz3q__qrcode-container",
  "text": "share-qr-code-module-scss-module__wUyz3q__text",
});
